import React from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';
import './ProfanityModal.css';

const ProfanityModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="profanity-modal-backdrop" onClick={onClose}>
      <div 
        className="profanity-modal-card" 
        onClick={e => e.stopPropagation()}
      >
        <div className="profanity-modal-header">
          <h3>Message Blocked</h3>
          <button className="profanity-modal-close-btn" onClick={onClose} aria-label="Close">
            <FiX />
          </button>
        </div>

        <div className="profanity-modal-body">
          <p className="profanity-modal-message">
            Please remove inappropriate language from your message before sending.
          </p>
        </div>

        <div className="profanity-modal-footer">
          <button 
            className="profanity-modal-btn profanity-modal-btn-primary" 
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProfanityModal;
